import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { InvoiceModel } from "api";
import { useInvoiceService } from "contexts/ServiceContext";
import { AI_EVENTS, useTrackEvent } from "../../useAppInsight";

const useInvoices = (
  contractNumber: number | undefined,
  searchTerm: string,
  filters?: InvoiceFilters,
  currentSort?: { key: keyof InvoiceModel; direction: string }
): UseQueryResult<InvoiceLineItem[]> => {
  const invoiceService = useInvoiceService();
  const trackQuery = useTrackEvent(AI_EVENTS.API_REQUEST, {
    contractNumber,
  });
  const trackQueryError = useTrackEvent(AI_EVENTS.API_ERROR, {
    contractNumber,
  });

  return useQuery({
    queryKey: [
      "contracts",
      { contractNumber },
      "invoices",
      { searchTerm, filters, currentSort },
    ],
    queryFn: () => {
      const invoiceEventId = trackQuery({
        endpoint: "Invoice/SearchGridView",
        parameters: { filters, sorting: currentSort, searchTerm },
      });
      return contractNumber
        ? invoiceService
            .listInvoices(contractNumber, searchTerm, filters, currentSort)
            .catch((err) => {
              trackQueryError(
                {
                  statusCode: err.statusCode,
                  message: err.message,
                },
                invoiceEventId
              );

              throw err;
            })
        : Promise.reject();
    },
    enabled: !!contractNumber,
    keepPreviousData: true,
    select: (data) => data.value,
  });
};

export default useInvoices;
